function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 3.236l-3.982 7.965a1.5 1.5 0 0 1-1.193.821l-7.626.763 5.308 5.308a1.5 1.5 0 0 1 .394 1.424L6.578 28.81l8.617-5.483a1.5 1.5 0 0 1 1.61 0l8.617 5.483-2.323-9.293a1.5 1.5 0 0 1 .394-1.424l5.308-5.308-7.626-.763a1.5 1.5 0 0 1-1.193-.821L16 3.236zm-5.648 6.824l4.306-8.613a1.5 1.5 0 0 1 2.684 0l4.306 8.613 8.402.84a1.5 1.5 0 0 1 .911 2.553l-5.854 5.854 2.56 10.234a1.5 1.5 0 0 1-2.261 1.63L16 25.185l-9.406 5.986a1.5 1.5 0 0 1-2.26-1.63l2.559-10.234-5.854-5.854A1.5 1.5 0 0 1 1.95 10.9l8.402-.84z"
});

var SvgReviewStar = function SvgReviewStar(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "00e5abcc25e6f5c8541943e3bfb164ca.svg";
export { SvgReviewStar as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/review-star.svg
// module id = null
// module chunks = 